import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {

// 第一步
// 查询艺考职业推荐方案列表
  selectArtSpecialityLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/artOccupationEvaluation/selectSpecialityLibrary",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
// 艺考新建职业推荐方案暂存/保存
  insertArtSpecialityLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/artOccupationEvaluation/insertSpecialityLibrary`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
// 获取职业推荐专业类别下拉框
getSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/artOccupationEvaluation/getSpeciality`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 查询艺考职业推荐方案列表
  getArtOccupationSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/artOccupationEvaluation/selectStudentSchemeList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 编辑
//   selectArtSpecialityLibrary({ commit }, params) {
//     return new Promise((resolve, reject) => {
//       axios({
//         method: "post",
//         url: "/artOccupationEvaluation/selectSpecialityLibrary",
//         params: params
//       }).then(response => {
//         resolve(response);
//       }).catch(error => {
//         reject(error);
//       });
//     });
//   },
  // 删除艺考职业推荐方案
  removeArtScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/artOccupationEvaluation/delStudentScheme",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};
